import { keysToSnake } from '#/api/adapters/wireCase';

/**
 * 採購訂單 create payload（camel → snake）。
 * 不送 purchaseOrderNo（由後端產生）。
 */
export function serializePurchaseOrderCreate(values) {
  const { purchaseOrderNo: _ignored, ...rest } = values ?? {};
  return keysToSnake(rest);
}

/**
 * 採購訂單 update payload（camel → snake）。
 * 含 updatedAt 樂觀鎖。
 */
export function serializePurchaseOrderUpdate(values) {
  return keysToSnake(values);
}
